import en from './en.json';

export type DesignSystemTranslationsType = typeof en;

export type DesignSystemLocaleType = 'en';

export const designSystemTranslations = {
  en,
};
